module.exports = __webpack_public_path__ + "static/media/excluir.d11a8ab8.png";